import { Directive, HostListener, inject, model } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: '[coreAutoHttps]',
})
export class AutoHttpsDirective {
  private ngControl = inject(NgControl);

  private readonly DUPLICATE_HTTPS_REGEX = /^(https:\/\/)+/i;
  private readonly VALID_PARTIAL_PROTOCOL_REGEX =
    /^(h|ht|htt|http|https|http:|https:|http:\/|https:\/|http:\/\/|https:\/\/)$/i;

  enableAutoHttps = model<boolean>(false, { alias: 'coreAutoHttps' });

  @HostListener('input', ['$event'])
  onInput(event: Event) {
    if (!this.enableAutoHttps()) return;

    const inputElement = event.target as HTMLInputElement;
    const currentValue = inputElement.value;

    if (!currentValue.trim()) {
      return;
    }

    if (this.VALID_PARTIAL_PROTOCOL_REGEX.test(currentValue)) {
      return;
    }

    let newValue = currentValue;

    if (newValue.startsWith('http') && !newValue.startsWith('https://')) {
      newValue = newValue.replace(/^https?(:?\/?)?/i, '');
    }

    newValue = newValue.replace(this.DUPLICATE_HTTPS_REGEX, 'https://');

    if (!newValue.startsWith('https://')) {
      newValue = 'https://' + newValue;
    }

    newValue = newValue.replace(this.DUPLICATE_HTTPS_REGEX, 'https://');

    if (newValue !== currentValue) {
      this.ngControl.control?.setValue(newValue);
    }
  }

  @HostListener('paste', ['$event'])
  onPaste(event: ClipboardEvent) {
    if (!this.enableAutoHttps()) return;

    event.preventDefault();
    let newValue = event.clipboardData?.getData('text') || '';

    if (newValue.startsWith('http') && !newValue.startsWith('https://')) {
      newValue = newValue.replace(/^https?(:?\/?)?/i, '');
    }

    newValue = newValue.replace(this.DUPLICATE_HTTPS_REGEX, 'https://');

    if (!newValue.startsWith('https://') && newValue.trim() !== '') {
      newValue = 'https://' + newValue;
    }

    newValue = newValue.replace(this.DUPLICATE_HTTPS_REGEX, 'https://');

    this.ngControl.control?.setValue(newValue);
  }
}
